import React, { useEffect, useState, useCallback } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Apiurl from "../environment/Apiurl";

function AddOutBilling() {
  const navigate = useNavigate();
  const [patients, setPatients] = useState([]);
  const [showPatientDropdown, setShowPatientDropdown] = useState(false);
  const [isLoadingPatients, setIsLoadingPatients] = useState(false);
  const [showmodal, setShowmodal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [doctorFees, setDoctorFees] = useState([]);
  const [treatmentCharges, setTreatmentCharges] = useState([]);
  const [serviceOptions, setServiceOptions] = useState([]);
  const [selectedService, setSelectedService] = useState("");
  const [showNewPatientForm, setShowNewPatientForm] = useState(false);
  const [generatedPatientId, setGeneratedPatientId] = useState("");
  const [isNewPatient, setIsNewPatient] = useState(false);
  const [getbillby, setbillby] = useState("");

  const [addData, setAddData] = useState({
    bill_invoice_no: "",
    hisNo: "",
    billDate: new Date().toISOString().split("T")[0],
    patientId: "",
    patientName: "",
    patientMobile: "",
    patientGender: "",
    patient_type: "",
    doctorName: "",
    department: "",
    procedure: "",
    category: "out",
    paymentMode: "",
    advancePaid: "0",
    balance: "0",
    bill_by: "",
  });

  const [services, setServices] = useState([]);
  const [newService, setNewService] = useState({
    id: "",
    select_service: "",
    serviceType: "",
    description: "",
    amount: "",
    additionalCharges: "",
  });
  const [isEditing, setIsEditing] = useState(false);
  const [doctor, setDoctor] = useState([]);
  const [errors, setErrors] = useState({});

  // Payment related states
  const [paymentData, setPaymentData] = useState({
    date: new Date().toISOString().split("T")[0],
    paymentMode: "",
    advancePaid: "",
    balance: "",
  });
  const [payments, setPayments] = useState([]);
  const [editIndex, setEditIndex] = useState(null);

  useEffect(() => {
    fetchPatientDetails();
    fetchDoctor();
    fetchGenerateBillInvoice();
    fetchServices();
  }, []);

  useEffect(() => {
    const storedName = localStorage.getItem("name");
    if (storedName) {
      setbillby(storedName);
    }
  }, []);

  useEffect(() => {
    // Update service options when patient_type changes
    if (addData.patient_type) {
      setServiceOptions(
        selectedService === "doctor_fees"
          ? doctorFees
          : treatmentCharges.filter(
              (charge) => charge.category === addData.patient_type,
            ),
      );
    }
  }, [addData.patient_type, selectedService, treatmentCharges, doctorFees]);

  const fetchServices = async () => {
    try {
      const treatmentResponse = await axios.get(`${Apiurl}/treatment_charge`);
      const doctorResponse = await axios.get(`${Apiurl}/doctor_fee_master`);
      setTreatmentCharges(treatmentResponse.data);
      setDoctorFees(doctorResponse.data);
      // Set initial service options based on patient_type
      setServiceOptions(
        addData.patient_type
          ? treatmentResponse.data.filter(
              (charge) => charge.category === addData.patient_type,
            )
          : treatmentResponse.data,
      );
    } catch (error) {
      console.error("Error fetching services:", error);
      setErrorMessage("Failed to load services. Please try again.");
      setTimeout(() => setErrorMessage(""), 3000);
    }
  };

  const fetchGenerateBillInvoice = async () => {
    try {
      const response = await axios.get(
        `${Apiurl}/generate_bill_management_invoice_id`,
        { params: { category: "out" } },
      );
      if (response.data && response.data.bill_invoice_no) {
        const invoiceNo = response.data.bill_invoice_no;
        setAddData((prev) => ({ ...prev, bill_invoice_no: invoiceNo }));
      } else {
        throw new Error("Invalid response format");
      }
    } catch (error) {
      console.error("Error generating invoice ID:", error);
      const tempInvoiceNo = "4H-OP-INV-0001";
      setAddData((prev) => ({ ...prev, bill_invoice_no: tempInvoiceNo }));
      setErrorMessage("Using temporary invoice number. Please verify later.");
      setTimeout(() => setErrorMessage(""), 3000);
    }
  };

  const fetchPatientDetails = async () => {
    try {
      setIsLoadingPatients(true);
      const response = await axios.get(`${Apiurl}/patient_details`);
      setPatients(response.data);
    } catch (error) {
      console.error("Error fetching patient details:", error);
      setErrorMessage("Failed to load patients. Please try again.");
      setTimeout(() => setErrorMessage(""), 3000);
    } finally {
      setIsLoadingPatients(false);
    }
  };

  const fetchDoctor = async () => {
    try {
      setIsLoadingPatients(true);
      const response = await axios.get(`${Apiurl}/doctor`);
      setDoctor(response.data);
    } catch (error) {
      console.error("Error fetching doctor details:", error);
      setErrorMessage("Failed to load doctors. Please try again.");
      setTimeout(() => setErrorMessage(""), 3000);
    } finally {
      setIsLoadingPatients(false);
    }
  };

  const handlePatientSelect = (patient) => {
    if (!showNewPatientForm) {
      setAddData((prev) => ({
        ...prev,
        patientId: patient.patient_id,
        patientName: `${patient.first_name} ${patient.last_name}`,
        patientMobile: patient.mobile_no,
        patientGender: patient.gender || "",
        hisNo: patient.patient_id,
      }));
    }
    setShowPatientDropdown(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setAddData((prev) => {
      const newData = { ...prev, [name]: value };

      if (name === "patient_type") {
        newData.hisNo = "";
        newData.patientId = "";
        newData.patientName = "";
        newData.patientMobile = "";
        newData.patientGender = "";
        setGeneratedPatientId("");
        setShowNewPatientForm(false);
        // Reset service selection when patient type changes
        setNewService({
          id: "",
          select_service: "",
          serviceType: "",
          description: "",
          amount: "",
          additionalCharges: "",
        });
        setSelectedService("");
        setShowPatientDropdown(true);
      }

      if (name === "advancePaid") {
        const total = calculateTotal();
        const balance = total - parseFloat(value || 0);
        newData.balance = isNaN(balance) ? "0" : balance.toFixed(2);
      }

      return newData;
    });
  };

  const handleServiceChange = (e) => {
    const { name, value } = e.target;
    setNewService((prev) => {
      const updatedService = { ...prev, [name]: value };

      if (name === "select_service") {
        setSelectedService(value);
        setServiceOptions(
          value === "doctor_fees"
            ? doctorFees
            : treatmentCharges.filter(
                (charge) => charge.category === addData.patient_type,
              ),
        );
        return {
          ...updatedService,
          serviceType: "",
          amount: "",
        };
      }

      if (name === "serviceType") {
        const selectedOption = serviceOptions.find(
          (option) => option.type === value,
        );
        if (selectedOption) {
          updatedService.amount = selectedOption.charge_per_treatment;
        } else {
          updatedService.amount = "";
        }
      }

      return updatedService;
    });
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleCancel = () => {
    setAddData({
      bill_invoice_no: "",
      hisNo: "",
      billDate: new Date().toISOString().split("T")[0],
      patientId: "",
      patientName: "",
      patientMobile: "",
      patientGender: "",
      patient_type: "",
      doctorName: "",
      department: "",
      procedure: "",
      category: "out",
      paymentMode: "",
      advancePaid: "0",
      balance: "0",
    });
    setNewService({
      id: "",
      select_service: "",
      serviceType: "",
      description: "",
      amount: "",
      additionalCharges: "",
    });
    setServices([]);
    setPayments([]);
    setIsEditing(false);
    setEditIndex(null);
    setSelectedService("");
    setServiceOptions(treatmentCharges);
    setGeneratedPatientId("");
    setShowNewPatientForm(false);
    setIsNewPatient(false);
    fetchGenerateBillInvoice();
    setSuccessMessage("Form has been reset");
    setTimeout(() => setSuccessMessage(""), 3000);
  };

  const removeService = (id) => {
    if (window.confirm("Are you sure you want to delete this service?")) {
      const updatedServices = services.filter((service) => service.id !== id);
      setServices(updatedServices);
      updateTotals(updatedServices);
      setSuccessMessage("Service removed successfully");
      setTimeout(() => setSuccessMessage(""), 3000);
    }
  };

  const editService = (id) => {
    const serviceToEdit = services.find((service) => service.id === id);
    if (serviceToEdit) {
      setNewService(serviceToEdit);
      setSelectedService(serviceToEdit.select_service);
      setServiceOptions(
        serviceToEdit.select_service === "doctor_fees"
          ? doctorFees
          : treatmentCharges.filter(
              (charge) => charge.category === addData.patient_type,
            ),
      );
      setIsEditing(true);
    }
  };

  const addService = () => {
    if (
      !newService.select_service ||
      !newService.serviceType ||
      !newService.amount
    ) {
      setErrorMessage("Please fill all required service fields");
      setTimeout(() => setErrorMessage(""), 3000);
      return;
    }

    let updatedServices;
    if (isEditing) {
      updatedServices = services.map((service) =>
        service.id === newService.id ? newService : service,
      );
    } else {
      const newEntry = { ...newService, id: Date.now().toString() };
      updatedServices = [...services, newEntry];
    }

    setServices(updatedServices);
    setIsEditing(false);
    updateTotals(updatedServices);

    setNewService({
      id: "",
      select_service: "",
      serviceType: "",
      description: "",
      amount: "",
      additionalCharges: "",
    });
    setSelectedService("");
    setServiceOptions(
      treatmentCharges.filter(
        (charge) => charge.category === addData.patient_type,
      ),
    );

    setTimeout(() => setSuccessMessage(""), 3000);
  };

  const updateTotals = (servicesArray) => {
    const subtotal = calculateSubtotal(servicesArray);
    const total = subtotal;
    const totalPaid = payments.reduce((sum, payment) => {
      return sum + parseFloat(payment.advancePaid || 0);
    }, 0);
    const balance = total - totalPaid;

    setAddData((prev) => ({
      ...prev,
      advancePaid: totalPaid.toFixed(2),
      balance: balance.toFixed(2),
    }));
  };

  const calculateSubtotal = useCallback(() => {
    return services.reduce((acc, service) => {
      const amt = parseFloat(service.amount) || 0;
      const extra = parseFloat(service.additionalCharges) || 0;
      return acc + amt + extra;
    }, 0);
  }, [services]);

  const calculateTotal = useCallback(() => {
    return calculateSubtotal();
  }, [services]);

  const calculateBalance = useCallback(() => {
    const total = calculateTotal();
    const paid = parseFloat(addData.advancePaid) || 0;
    return total - paid;
  }, [calculateTotal, addData.advancePaid]);

  const handlePaymentInputChange = (e) => {
    const { name, value } = e.target;
    setPaymentData((prev) => {
      const updated = {
        ...prev,
        [name]: value,
      };

      if (name === "advancePaid") {
        const total = calculateTotal();
        const paidAmount = parseFloat(value || 0);
        const totalPaid =
          payments.reduce((sum, p) => sum + parseFloat(p.advancePaid || 0), 0) +
          paidAmount;
        updated.balance = (total - totalPaid).toFixed(2);
      }

      return updated;
    });
  };

  const handleAddOrUpdatePayment = () => {
    if (
      !paymentData.date ||
      !paymentData.paymentMode ||
      !paymentData.advancePaid
    ) {
      setErrorMessage("Please fill all payment fields");
      setTimeout(() => setErrorMessage(""), 3000);
      return;
    }

    const paidAmount = parseFloat(paymentData.advancePaid);
    if (paidAmount <= 0) {
      setErrorMessage("Payment amount must be greater than 0");
      setTimeout(() => setErrorMessage(""), 3000);
      return;
    }

    const total = calculateTotal();
    let totalPaid = payments.reduce(
      (sum, p) => sum + parseFloat(p.advancePaid || 0),
      0,
    );

    if (editIndex !== null) {
      totalPaid -= parseFloat(payments[editIndex].advancePaid || 0);
    }

    totalPaid += paidAmount;
    const balance = total - totalPaid;

    if (balance < 0) {
      setErrorMessage("Payment amount exceeds the total due");
      setTimeout(() => setErrorMessage(""), 3000);
      return;
    }

    const updatedPayment = {
      ...paymentData,
      balance: balance.toFixed(2),
    };

    let updatedPayments;
    if (editIndex !== null) {
      updatedPayments = [...payments];
      updatedPayments[editIndex] = updatedPayment;
    } else {
      updatedPayments = [...payments, updatedPayment];
    }

    setPayments(updatedPayments);
    setEditIndex(null);

    setAddData((prev) => ({
      ...prev,
      advancePaid: totalPaid.toFixed(2),
      balance: balance.toFixed(2),
      paymentMode: paymentData.paymentMode,
    }));

    setPaymentData({
      date: new Date().toISOString().split("T")[0],
      paymentMode: "",
      advancePaid: "",
      balance: "",
    });

    setTimeout(() => setSuccessMessage(""), 3000);
  };

  const handleEditPayment = (index) => {
    setPaymentData(payments[index]);
    setEditIndex(index);
  };

  const handleDeletePayment = (index) => {
    if (window.confirm("Are you sure you want to delete this payment?")) {
      const paymentToRemove = payments[index];
      const updatedPayments = [...payments];
      updatedPayments.splice(index, 1);

      const total = calculateTotal();
      const totalPaid = updatedPayments.reduce(
        (sum, p) => sum + parseFloat(p.advancePaid || 0),
        0,
      );
      const balance = total - totalPaid;

      setPayments(updatedPayments);
      setAddData((prev) => ({
        ...prev,
        advancePaid: totalPaid.toFixed(2),
        balance: balance.toFixed(2),
      }));

      if (editIndex === index) {
        setEditIndex(null);
        setPaymentData({
          date: new Date().toISOString().split("T")[0],
          paymentMode: "",
          advancePaid: "",
          balance: "",
        });
      }

      setSuccessMessage("Payment deleted successfully");
      setTimeout(() => setSuccessMessage(""), 3000);
    }
  };

  const handleGeneratePatientId = async () => {
    if (!addData.patient_type) {
      setErrorMessage("Please select Patient Type first");
      setTimeout(() => setErrorMessage(""), 3000);
      return;
    }

    try {
      const generateUrl =
        addData.patient_type === "Yoga"
          ? `${Apiurl}/generate_patient_id`
          : `${Apiurl}/generate_homeo_id`;
      const res = await axios.get(generateUrl);
      const patient_id = res.data.patient_id;

      setGeneratedPatientId(patient_id);
      setAddData((prev) => ({
        ...prev,
        hisNo: patient_id,
        patientId: patient_id,
        patientName: "",
        patientMobile: "",
        patientGender: "",
      }));
      setShowNewPatientForm(true);
      setIsNewPatient(true);
      setSuccessMessage("Patient ID generated successfully");
      setTimeout(() => setSuccessMessage(""), 3000);
    } catch (error) {
      console.error("Error generating patient ID:", error);
      setErrorMessage("Failed to generate patient ID. Please try again.");
      setTimeout(() => setErrorMessage(""), 3000);
    }
  };

  // const handleSave = async () => {
  //   if (
  //     !addData.bill_invoice_no ||
  //     !addData.billDate ||
  //     !addData.patientId ||
  //     !addData.department ||
  //     !addData.paymentMode
  //   ) {
  //     setErrorMessage(
  //       "Please fill all required fields (Bill No, Bill Date, Patient, Department, Payment Mode)"
  //     );
  //     setTimeout(() => setErrorMessage(""), 3000);
  //     return;
  //   }

  //   if (services.length === 0) {
  //     setErrorMessage("Please add at least one service");
  //     setTimeout(() => setErrorMessage(""), 3000);
  //     return;
  //   }

  //   if (isNewPatient) {
  //     if (
  //       !addData.patientName ||
  //       !addData.patientMobile ||
  //       !addData.patientGender
  //     ) {
  //       setErrorMessage("Please fill all patient details");
  //       setTimeout(() => setErrorMessage(""), 3000);
  //       return;
  //     }

  //     try {
  //       const [first_name, ...lastNameParts] = addData.patientName
  //         .trim()
  //         .split(" ");
  //       const last_name = lastNameParts.join(" ") || "";

  //       const payload = {
  //         patient_id: addData.patientId,
  //         patient_type: addData.patient_type,
  //         first_name,
  //         last_name,
  //         mobile_no: addData.patientMobile,
  //         gender: addData.patientGender,
  //       };

  //       await axios.post(`${Apiurl}/patient_details`, payload);
  //       await fetchPatientDetails();

  //       console.log("Data was saved to patient_Details", payload);
  //       setIsNewPatient(false);
  //       setShowNewPatientForm(false);
  //       setGeneratedPatientId("");
  //       setSuccessMessage("New patient added successfully");
  //       setTimeout(() => setSuccessMessage(""), 3000);
  //     } catch (error) {
  //       console.error("Error adding new patient:", error);
  //       setErrorMessage("Failed to add new patient. Please try again.");
  //       setTimeout(() => setErrorMessage(""), 3000);
  //       return;
  //     }
  //   }

  //   const payload = {
  //     bill_invoice_no: addData.bill_invoice_no,
  //     bill_date: addData.billDate,
  //     patient_id: addData.patientId,
  //     patient_name: addData.patientName,
  //     patient_mobile: addData.patientMobile,
  //     patient_gender: addData.patientGender,
  //     doctor_id: addData.doctorName,
  //     department: addData.department,
  //     payment_type: addData.paymentMode || "",
  //     total_amount: calculateTotal().toFixed(2),
  //     category: addData.category,
  //     advance_paid: addData.advancePaid || "0",
  //     balance: calculateBalance().toFixed(2),
  //     bill_by: getbillby,
  //     created_by: "",
  //     bill_list: services.map((service) => ({
  //       bill_invoice_no: addData.bill_invoice_no,
  //       select_service: service.select_service,
  //       service_type: service.serviceType,
  //       description: service.description,
  //       fees: service.amount,
  //       additional_charges: service.additionalCharges,
  //       created_by: "",
  //     })),
  //     payments: payments.map((payment) => ({
  //       bill_invoice_no: addData.bill_invoice_no,
  //       date: payment.date,
  //       payment_mode: payment.paymentMode,
  //       amount: payment.advancePaid,
  //       balance: payment.balance,
  //       created_by: "",
  //     })),
  //   };

  //   try {
  //     await axios.post(`${Apiurl}/billing_management`, payload);

  //     console.log("the data was billing ", payload);
  //     navigate(
  //       `/billing/out-billing/add-billing/op-bill/${addData.bill_invoice_no}`,
  //       {
  //         state: {
  //           patientName: addData.patientName,
  //           patientMobile: addData.patientMobile,
  //           patientGender: addData.patientGender,
  //         },
  //       }
  //     );
  //   } catch (error) {
  //     console.error("Error saving billing:", error);
  //     setErrorMessage(
  //       `Failed to save billing: ${
  //         error.response?.data?.message || error.message
  //       }`
  //     );
  //     setTimeout(() => setErrorMessage(""), 3000);
  //   }
  // };

  const handleSave = async () => {
    if (
      !addData.bill_invoice_no ||
      !addData.billDate ||
      !addData.patientId ||
      !addData.department ||
      !addData.paymentMode
    ) {
      setErrorMessage(
        "Please fill all required fields (Bill No, Bill Date, Patient, Department, Payment Mode)",
      );
      setTimeout(() => setErrorMessage(""), 3000);
      return;
    }

    if (services.length === 0) {
      setErrorMessage("Please add at least one service");
      setTimeout(() => setErrorMessage(""), 3000);
      return;
    }

    // Prepare the payload
    const payload = {
      bill_invoice_no: addData.bill_invoice_no,
      bill_date: addData.billDate,
      patient_id: addData.patientId,
      patient_name: addData.patientName,
      patient_mobile: addData.patientMobile,
      patient_gender: addData.patientGender,
      doctor_id: addData.doctorName,
      department: addData.department,
      payment_type: addData.paymentMode || "",
      total_amount: calculateTotal().toFixed(2),
      category: addData.category,
      advance_paid: addData.advancePaid || "0",
      balance: calculateBalance().toFixed(2),
      bill_by: getbillby,
      created_by: "",
      is_new_patient: isNewPatient, // This tells backend if it's a new patient
      bill_list: services.map((service) => ({
        bill_invoice_no: addData.bill_invoice_no,
        select_service: service.select_service,
        service_type: service.serviceType,
        description: service.description,
        fees: service.amount,
        additional_charges: service.additionalCharges,
        created_by: "",
      })),
      payments: payments.map((payment) => ({
        bill_invoice_no: addData.bill_invoice_no,
        date: payment.date,
        payment_mode: payment.paymentMode,
        amount: payment.advancePaid,
        balance: payment.balance,
        created_by: "",
      })),
    };

    try {
      const response = await axios.post(
        `${Apiurl}/billing_management`,
        payload,
      );

      console.log("Billing saved successfully:", response.data);

      // Update the data with final IDs if they were changed
      let finalInvoiceNo =
        response.data.final_invoice_no || addData.bill_invoice_no;
      let finalPatientId = response.data.final_patient_id || addData.patientId;

      // Show success message with changes if any
      if (response.data.invoice_changed || response.data.patient_id_changed) {
        let message = "Billing saved successfully";
        if (response.data.invoice_changed) {
          message += ` - Invoice number changed to ${finalInvoiceNo}`;
        }
        if (response.data.patient_id_changed) {
          message += ` - Patient ID changed to ${finalPatientId}`;
        }
        setSuccessMessage(message);
      } else {
        setSuccessMessage("Billing saved successfully");
      }

      // Navigate with the final invoice number
      setTimeout(() => {
        navigate(`/billing/out-billing/add-billing/op-bill/${finalInvoiceNo}`, {
          state: {
            patientName: addData.patientName,
            patientMobile: addData.patientMobile,
            patientGender: addData.patientGender,
            patientId: finalPatientId,
          },
        });
      }, 2000);
    } catch (error) {
      console.error("Error saving billing:", error);
      setErrorMessage(
        `Failed to save billing: ${
          error.response?.data?.message || error.message
        }`,
      );
      setTimeout(() => setErrorMessage(""), 3000);
    }
  };

  const filteredPatients = patients.filter((patient) => {
    // First filter by selected patient type
    if (
      addData.patient_type &&
      patient.patient_type &&
      patient.patient_type.toLowerCase() !== addData.patient_type.toLowerCase()
    ) {
      return false;
    }

    // Search by Patient ID, First Name, Last Name, or Mobile
    const searchValue = (addData.hisNo || "").toLowerCase().trim();

    if (!searchValue) {
      return true;
    }

    return (
      patient.patient_id?.toLowerCase().includes(searchValue) ||
      patient.first_name?.toLowerCase().includes(searchValue) ||
      patient.last_name?.toLowerCase().includes(searchValue) ||
      patient.mobile_no?.toLowerCase().includes(searchValue)
    );
  });

  return (
    <div className="p-3">
      {successMessage && (
        <div
          className="alert alert-success alert-dismissible fade show"
          role="alert"
        >
          {successMessage}
          <button
            type="button"
            className="btn-close"
            onClick={() => setSuccessMessage("")}
          ></button>
        </div>
      )}
      {errorMessage && (
        <div
          className="alert alert-danger alert-dismissible fade show"
          role="alert"
        >
          {errorMessage}
          <button
            type="button"
            className="btn-close"
            onClick={() => setErrorMessage("")}
          ></button>
        </div>
      )}

      <div
        className="card py-2 mb-2"
        style={{ backgroundColor: "#01AEBE", color: "white" }}
      >
        <div className="row">
          <div className="col-lg-12 text-white">
            <h5 className="text-center">Out Patient Billing</h5>
          </div>
        </div>
      </div>

      <div className="row mb-2 mx-auto">
        <div className="card  col-lg-9  col-md-9 ">
          <div className="row mt-2">
            <div className="col-md-6 col-lg-2">
              <label className="form-label fw-semibold mb-1">
                Patient Type
              </label>
              <select
                className="form-control form-control-sm"
                name="patient_type"
                value={addData.patient_type}
                onChange={handleInputChange}
              >
                <option value="" disabled>
                  Select Type
                </option>
                <option value="Homeopathy">Homeopathy</option>
                <option value="Yoga">Yoga</option>
              </select>
            </div>

            <div className="col-md-6 col-lg-2">
              <label className="form-label fw-semibold mb-1">Patient ID</label>
              <div style={{ position: "relative" }}>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  name="hisNo"
                  value={addData.hisNo}
                  onChange={handleInputChange}
                  onFocus={() => setShowPatientDropdown(true)}
                  onBlur={() =>
                    setTimeout(() => setShowPatientDropdown(false), 200)
                  }
                  placeholder="Enter Patient ID"
                />
                {showPatientDropdown && !showNewPatientForm && (
                  <div
                    style={{
                      position: "absolute",
                      zIndex: 1000,
                      width: "fit-content",
                      paddingLeft: "20px",
                      paddingRight: "20px",
                      maxHeight: "200px",
                      overflowY: "auto",
                      backgroundColor: "white",
                      border: "1px solid #ddd",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                      // marginTop: "-18px",
                    }}
                  >
                    {isLoadingPatients ? (
                      <div className="dropdown-item">Loading...</div>
                    ) : filteredPatients.length > 0 ? (
                      filteredPatients.map((patient, index) => (
                        <div
                          key={patient.patient_id || index}
                          className="dropdown-item"
                          style={{
                            cursor: "pointer",
                            padding: "8px 12px",
                            borderBottom: "1px solid #eee",
                          }}
                          onMouseDown={() => handlePatientSelect(patient)}
                        >
                          <div className="fw-semibold">
                            {patient.first_name} {patient.last_name}
                          </div>

                          <small className="text-muted">
                            ID: {patient.patient_id}
                            {patient.mobile_no ? ` | ${patient.mobile_no}` : ""}
                          </small>
                        </div>
                      ))
                    ) : (
                      <div className="dropdown-item text-muted">
                        No patients found
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>

            <div className="col-lg-1 mt-4">
              <button
                className="btn btn-primary"
                onClick={handleGeneratePatientId}
              >
                +
              </button>
            </div>

            <div className="col-md-6 col-lg-2">
              <label className="form-label fw-semibold mb-1">
                Patient Name
              </label>
              <input
                type="text"
                className="form-control form-control-sm"
                name="patientName"
                value={addData.patientName}
                onChange={handleInputChange}
                readOnly={!showNewPatientForm}
                placeholder={showNewPatientForm ? "Enter Full Name" : ""}
              />
            </div>

            <div className="col-md-6 col-lg-2">
              <label className="form-label fw-semibold mb-1">
                Patient Mobile
              </label>
              <input
                type="text"
                className="form-control form-control-sm"
                name="patientMobile"
                value={addData.patientMobile}
                onChange={handleInputChange}
                readOnly={!showNewPatientForm}
                placeholder={showNewPatientForm ? "Enter Mobile Number" : ""}
              />
            </div>

            {showNewPatientForm && (
              <div className="col-md-6 col-lg-3">
                <label className="form-label fw-semibold mb-1">Gender</label>
                <select
                  className="form-control form-control-sm"
                  name="patientGender"
                  value={addData.patientGender}
                  onChange={handleInputChange}
                  disabled={!showNewPatientForm}
                >
                  <option value="">Select</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>
              </div>
            )}

            <div className="col-md-6 col-lg-3">
              <label className="form-label fw-semibold mb-1">Department</label>
              <select
                className="form-control form-control-sm"
                name="department"
                value={addData.department}
                onChange={(e) => {
                  handleInputChange(e);
                  setSelectedDepartment(e.target.value);
                }}
              >
                <option value="">Select Department</option>
                {[...new Set(doctor.map((doc) => doc.department))].map(
                  (dept, index) => (
                    <option key={index} value={dept}>
                      {dept}
                    </option>
                  ),
                )}
              </select>
            </div>

            <div className="col-md-6 col-lg-3">
              <label className="form-label fw-semibold mb-1">Doctor Name</label>
              <select
                className="form-control form-control-sm"
                name="doctorName"
                value={addData.doctorName}
                onChange={handleInputChange}
                disabled={!selectedDepartment}
              >
                <option value="">Select Doctor</option>
                {doctor
                  .filter((doc) => doc.department === selectedDepartment)
                  .map((doc, index) => (
                    <option key={index} value={doc.doctor_id}>
                      {doc.doctor_id} - {doc.doctor_name}
                    </option>
                  ))}
              </select>
            </div>
          </div>
        </div>

        <div className="card col-lg-3 col-md-3">
          <div className="row mt-2">
            <div className="col-md-6 col-lg-6">
              <label className="form-label fw-semibold mb-1">Bill Date</label>
              <input
                type="date"
                className="form-control form-control-sm"
                name="billDate"
                value={addData.billDate}
                onChange={handleInputChange}
              />
            </div>
            <div className="col-md-6 col-lg-6">
              <label className="form-label fw-semibold mb-1">Invoice No</label>
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Auto Fill"
                name="bill_invoice_no"
                value={addData.bill_invoice_no}
                readOnly
              />
              {errors.bill_invoice_no && (
                <small className="text-danger">{errors.bill_invoice_no}</small>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="card shadow-sm mb-2">
        <div className="card-body">
          <div className="row g-2 rounded">
            <div className="col-md-6 col-lg-2">
              <label className="form-label fw-semibold mb-1">
                Select Service
              </label>
              <select
                className="form-select form-select-sm"
                name="select_service"
                value={newService.select_service}
                onChange={handleServiceChange}
                required
                disabled={!addData.patient_type}
              >
                <option value="" disabled>
                  Select Service
                </option>
                <option value="treatment">Treatment charge</option>
                <option value="doctor_fees">Doctor fee</option>
              </select>
            </div>
            <div className="col-md-6 col-lg-3">
              <label className="form-label fw-semibold mb-1">
                Service Type
              </label>
              <select
                className="form-select form-select-sm"
                name="serviceType"
                value={newService.serviceType}
                onChange={handleServiceChange}
                required
                disabled={!newService.select_service}
              >
                <option value="">Select Service Type</option>
                {serviceOptions.map((service) => (
                  <option key={service._id} value={service.type}>
                    {service.type}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-6 col-lg-3">
              <label className="form-label fw-semibold mb-1">Description</label>
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Enter Description"
                name="description"
                value={newService.description}
                onChange={handleServiceChange}
              />
            </div>
            <div className="col-md-6 col-lg-2">
              <label className="form-label fw-semibold mb-1">Fee (₹)</label>
              <input
                type="number"
                className="form-control form-control-sm"
                placeholder="Amount"
                name="amount"
                value={newService.amount}
                onChange={handleServiceChange}
                required
                min="0"
                step="0.01"
              />
            </div>
            <div className="col-md-12 col-lg-2 d-flex align-items-center gap-2">
              <button
                className={`btn btn-sm ${
                  isEditing ? "btn-warning" : "btn-primary"
                }`}
                onClick={addService}
              >
                {isEditing ? "Update" : "Add"}
              </button>
              <button
                className="btn btn-success btn-sm"
                onClick={() => setShowmodal(true)}
              >
                Payment
              </button>
            </div>
          </div>

          <div className="table-responsive mt-3">
            <table className="table table-sm table-striped">
              <thead>
                <tr>
                  <th style={{ backgroundColor: "#01AEBE", color: "white" }}>
                    S.No
                  </th>
                  <th style={{ backgroundColor: "#01AEBE", color: "white" }}>
                    Service Type
                  </th>
                  <th style={{ backgroundColor: "#01AEBE", color: "white" }}>
                    Description
                  </th>
                  <th style={{ backgroundColor: "#01AEBE", color: "white" }}>
                    Amount
                  </th>
                  <th style={{ backgroundColor: "#01AEBE", color: "white" }}>
                    Total
                  </th>
                  <th style={{ backgroundColor: "#01AEBE", color: "white" }}>
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {services.map((service, index) => (
                  <tr key={service.id}>
                    <td>{index + 1}</td>
                    <td>{service.serviceType}</td>
                    <td>{service.description}</td>
                    <td>₹{parseFloat(service.amount).toFixed(2)}</td>
                    <td>
                      ₹
                      {(
                        parseFloat(service.amount) +
                        parseFloat(service.additionalCharges || 0)
                      ).toFixed(2)}
                    </td>
                    <td>
                      <div className="btn-group" role="group">
                        <button
                          className="btn btn-outline-primary btn-sm"
                          onClick={() => editService(service.id)}
                          title="Edit"
                        >
                          <i className="fas fa-edit"></i>
                        </button>
                        <button
                          className="btn btn-outline-danger btn-sm"
                          onClick={() => removeService(service.id)}
                          title="Delete"
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
                {services.length === 0 && (
                  <tr>
                    <td colSpan="7" className="text-center text-muted py-3">
                      No services added yet
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12">
          <div className="card shadow-sm">
            <div className="card-body py-3">
              <div className="row">
                <div className="col-lg-8">
                  <div className="row g-3">
                    <div className="col-md-4">
                      <div className="card card-body bg-success text-white py-2">
                        <label className="form-label fw-bold mb-1">
                          Net Total
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="Net Total"
                          value={`₹${calculateTotal().toFixed(2)}`}
                          readOnly
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="card card-body bg-primary text-white py-2">
                        <label className="form-label fw-bold mb-1">Paid</label>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="Paid"
                          value={`₹${addData.advancePaid}`}
                          readOnly
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="card card-body bg-secondary text-white py-2">
                        <label className="form-label fw-bold mb-1">
                          Balance
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="Balance"
                          value={`₹${addData.balance}`}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 d-flex align-items-center justify-content-center">
                  <div className="d-flex gap-5 flex-wrap">
                    <button
                      className="btn btn-danger"
                      onClick={() => navigate("/billing/out-billing")}
                    >
                      Back
                    </button>
                    <button
                      className="btn btn-secondary"
                      onClick={handleCancel}
                    >
                      Reset
                    </button>
                    <button
                      className="btn btn-success"
                      style={{ backgroundColor: "#01AEBE" }}
                      onClick={handleSave}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`modal fade ${showmodal ? "show" : ""}`}
        style={{
          display: showmodal ? "block" : "none",
          background: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content p-3">
            <div className="d-flex align-items-center justify-content-between mb-3">
              <h5>Payment</h5>
              <button
                className="btn btn-close"
                onClick={() => {
                  setShowmodal(false);
                  setPaymentData({
                    date: new Date().toISOString().split("T")[0],
                    paymentMode: "",
                    advancePaid: "",
                    balance: "",
                  });
                  setEditIndex(null);
                }}
              ></button>
            </div>

            <div className="row g-1">
              <div className="col-md-4 col-lg-2">
                <label className="form-label fw-bold mb-1">Net Total</label>
                <input
                  type="text"
                  className="form-control fw-bold"
                  placeholder="Net Total"
                  value={`₹${calculateTotal().toFixed(2)}`}
                  readOnly
                />
              </div>
              <div className="col-md-3 col-lg-3">
                <label className="form-label fw-semibold">Date</label>
                <input
                  type="date"
                  className="form-control form-control-sm"
                  name="date"
                  value={paymentData.date}
                  onChange={handlePaymentInputChange}
                />
              </div>
              <div className="col-md-3 col-lg-2">
                <label className="form-label fw-semibold">Pay Type</label>
                <select
                  className="form-select form-select-sm"
                  name="paymentMode"
                  value={paymentData.paymentMode}
                  onChange={handlePaymentInputChange}
                >
                  <option value="">Select Pay</option>
                  <option value="Cash">Cash</option>
                  <option value="Card">Card</option>
                  <option value="UPI">UPI</option>
                  <option value="Net Banking">Net Banking</option>
                </select>
              </div>
              <div className="col-md-2 col-lg-2">
                <label className="form-label fw-semibold">Paid (₹)</label>
                <input
                  type="number"
                  className="form-control form-control-sm"
                  name="advancePaid"
                  value={paymentData.advancePaid}
                  onChange={handlePaymentInputChange}
                  min="0"
                  step="0.01"
                />
              </div>
              <div className="col-md-3 col-lg-2">
                <label className="form-label fw-semibold">Balance (₹)</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={paymentData.balance}
                  readOnly
                />
              </div>
              <div className="col-md-1" style={{ marginTop: "35px" }}>
                <button
                  className="btn btn-success btn-sm"
                  onClick={handleAddOrUpdatePayment}
                >
                  {editIndex !== null ? "Update" : "Add"}
                </button>
              </div>
            </div>

            <table className="table table-bordered table-sm mt-3">
              <thead>
                <tr>
                  <th style={{ backgroundColor: "#01AEBE", color: "white" }}>
                    S.no
                  </th>
                  <th style={{ backgroundColor: "#01AEBE", color: "white" }}>
                    Date
                  </th>
                  <th style={{ backgroundColor: "#01AEBE", color: "white" }}>
                    Pay Type
                  </th>
                  <th style={{ backgroundColor: "#01AEBE", color: "white" }}>
                    Paid (₹)
                  </th>
                  <th style={{ backgroundColor: "#01AEBE", color: "white" }}>
                    Balance (₹)
                  </th>
                  <th style={{ backgroundColor: "#01AEBE", color: "white" }}>
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {payments.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-center text-muted">
                      No records
                    </td>
                  </tr>
                ) : (
                  payments.map((pay, i) => (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td>{pay.date}</td>
                      <td>{pay.paymentMode}</td>
                      <td>{pay.advancePaid}</td>
                      <td>{pay.balance}</td>
                      <td>
                        <i
                          className="fas fa-edit text-primary me-2"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleEditPayment(i)}
                        ></i>
                        <i
                          className="fas fa-trash text-danger"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleDeletePayment(i)}
                        ></i>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
            <div className="d-flex justify-content-end">
              <button
                className="btn btn-sm btn-success"
                onClick={() => setShowmodal(false)}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddOutBilling;
